import React, { useState } from "react";
import { MinimumAttendeesSettingModalProps } from "./types";
import {
  ButtonSection,
  CancelContainer,
  Container,
  ContentContainer,
  Divider,
  InfoBox,
  InfoSection,
  MainSection,
  TitleContainer,
} from "./MinimumAttendeesSettingModal.styles";
import UI from "@mile-meeting/mile-ui";
import Modal from "react-modal";
import { TAttendeeLimit } from "apis/meetings/meeting-room";
import MeetingRoomInfo from "./MeetingRoomInfo";
import MinimumAttendeesSettingItemList, {
  TTimeSlotMinAttendeesPolicy,
} from "./MinimumAttendeesSetting/MinimumAttendeesSettingList/MinimumAttendeesSettingItemList";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    maxHeight: "90vh",
    width: "600px",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    padding: "0",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

Modal.setAppElement("#root");

const MinimumAttendeesSettingModal: React.FC<MinimumAttendeesSettingModalProps> = ({
  modalIsOpen,
  closeModal,
  onUpdate,
  room,
}) => {
  const [attendeeLimits, setAttendeeLimits] = useState<TAttendeeLimit[]>([]);
  const [enableAddPolicyButton, setEnableAddPolicyButton] = useState<boolean>(true);
  const guideAttendeeNum = Math.ceil((room?.capacity ?? 1) * 0.3);

  const onChangeAttendeeLimits = (policies: TTimeSlotMinAttendeesPolicy[]) => {
    checkEnableAeddPolicyButton(policies);

    const attendeeLimits: TAttendeeLimit[] = policies.reduce<TAttendeeLimit[]>((acc, policy) => {
      if (policy.startTime && policy.endTime && policy.minAttendeeNum !== undefined) {
        acc.push({
          id: policy.id,
          startTime: policy.startTime,
          endTime: policy.endTime,
          minAttendeeNum: policy.minAttendeeNum,
        });
      }
      return acc;
    }, []);

    setAttendeeLimits(attendeeLimits);
  };

  const checkEnableAeddPolicyButton = (policies: TTimeSlotMinAttendeesPolicy[]) => {
    // INFO: 에러 존재 시, 버튼 비활성화
    let isEnabled = true;
    const hasError = policies.some((policy) => (policy.errorType?.length ?? 0) > 0);
    if (hasError) {
      isEnabled = false;
    }

    // INFO: 빈 값 존재 시, 버튼 비활성화
    const hasEmptyValue = policies.some(
      (policy) => !policy.startTime || !policy.endTime || policy.minAttendeeNum === undefined
    );
    if (hasEmptyValue) {
      isEnabled = false;
    }

    setEnableAddPolicyButton(isEnabled);
  };

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelContainer>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelContainer>
        <TitleContainer>
          <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-neutral)">
            최소 참석 인원 설정
          </UI.Typography>
        </TitleContainer>
        <ContentContainer>
          <MainSection>
            <InfoSection>
              <MeetingRoomInfo room={room}></MeetingRoomInfo>
              <InfoBox>
                <UI.Icon name="info" size={20} color="var(--alias-color-primary-normal)" />
                <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
                  Mile은 회의실 수용 인원 대비 30% 이상이 참석하는 것을 권장 드립니다.
                  <br />
                  해당 회의실의 권장 최소 참석 인원은 {guideAttendeeNum}인입니다.
                </UI.Typography>
              </InfoBox>
            </InfoSection>
            <Divider />
            <MinimumAttendeesSettingItemList room={room} onChange={onChangeAttendeeLimits} />
          </MainSection>
          <ButtonSection>
            <UI.Button
              title="적용하기"
              size="large"
              primary
              disabled={!enableAddPolicyButton}
              onClick={() => {
                if (enableAddPolicyButton) onUpdate?.(attendeeLimits);
              }}
            />
          </ButtonSection>
        </ContentContainer>
      </Container>
    </Modal>
  );
};

export default React.memo(MinimumAttendeesSettingModal);
